module.exports = __webpack_public_path__ + "static/media/Screenshott@2x.e176fecb.png";